import { makeAutoObservable } from 'mobx';

import { getDeviceSetting, setDeviceSetting } from '@/utils/localStorage';

const LAST_SEEN_KEY = 'changelog-last-seen';
const DISMISS_STREAK_KEY = 'changelog-dismiss-streak';
const KEEP_SHOWING_COUNT_KEY = 'changelog-keep-showing-count';
const SIDEBAR_HIDDEN_KEY = 'changelog-sidebar-hidden';

const ASK_AT_DISMISS_STREAK = [3, 6];

class ChangelogSeenStore {
  lastSeenId: string | null = getDeviceSetting(LAST_SEEN_KEY);
  dismissStreak = Number(getDeviceSetting(DISMISS_STREAK_KEY) ?? 0);
  keepShowingCount = Number(getDeviceSetting(KEEP_SHOWING_COUNT_KEY) ?? 0);
  isSidebarHidden = getDeviceSetting(SIDEBAR_HIDDEN_KEY) === 'true';

  constructor() {
    makeAutoObservable(this);
  }

  get shouldAskOnDismiss() {
    const askAtStreak = ASK_AT_DISMISS_STREAK[this.keepShowingCount];
    return askAtStreak !== undefined && this.dismissStreak + 1 >= askAtStreak;
  }

  markSeen(entryId: string) {
    this.lastSeenId = entryId;
    setDeviceSetting(LAST_SEEN_KEY, entryId);
  }

  markOpened(entryId: string | undefined) {
    if (entryId) this.markSeen(entryId);
    this.setDismissStreak(0);
  }

  dismiss(entryId: string) {
    this.markSeen(entryId);
    this.setDismissStreak(this.dismissStreak + 1);
  }

  keepShowing(entryId: string) {
    this.markSeen(entryId);
    this.setDismissStreak(0);
    this.keepShowingCount += 1;
    setDeviceSetting(KEEP_SHOWING_COUNT_KEY, String(this.keepShowingCount));
  }

  stopShowing(entryId: string) {
    this.markSeen(entryId);
    this.setSidebarHidden(true);
  }

  setSidebarHidden(isHidden: boolean) {
    this.isSidebarHidden = isHidden;
    setDeviceSetting(SIDEBAR_HIDDEN_KEY, String(isHidden));
    if (!isHidden) this.setDismissStreak(0);
  }

  private setDismissStreak(streak: number) {
    this.dismissStreak = streak;
    setDeviceSetting(DISMISS_STREAK_KEY, String(streak));
  }
}

export const changelogSeenStore = new ChangelogSeenStore();
